import * as $runtime from "../runtime.js";
import * as Affjax$dRequestBody from "../Affjax.RequestBody/index.js";
import * as Affjax$dRequestHeader from "../Affjax.RequestHeader/index.js";
import * as Affjax$dResponseFormat from "../Affjax.ResponseFormat/index.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dArray$dNonEmpty$dSerialized from "../Data.Array.NonEmpty.Serialized/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dHTTP$dMethod from "../Data.HTTP.Method/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dIndex from "../Foreign.Index/index.js";
import * as Foreign$dJSON from "../Foreign.JSON/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dCountries from "../Restaumatic.Countries/index.js";
import * as Restaumatic$dServices$dDelivery from "../Restaumatic.Services.Delivery/index.js";
import * as Utils$dDataLoading from "../Utils.DataLoading/index.js";
const readDeliveryInfo = info => (
  {
    restaurantId: info.restaurant_id,
    restaurantName: info.restaurant_name,
    restaurantSlug: info.restaurant_slug,
    path: info.path,
    deliveryCost: info.delivery_cost,
    freeThreshold: info.free_threshold,
    minOrderValue: info.min_order_value
  }
);
const fromRawDeliveryResponse = restaurantId => response => {
  if (
    (() => {
      if (restaurantId.tag === "Nothing") { return true; }
      if (restaurantId.tag === "Just") { return false; }
      $runtime.fail();
    })() || Data$dFoldable.foldableArray.foldMap({mempty: false, Semigroup0: () => ({append: v => v1 => v || v1})})(info => {
      if (restaurantId.tag === "Just") { return info.restaurant_id === restaurantId._1; }
      return false;
    })(response.restaurants)
  ) {
    return Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure(Restaumatic$dServices$dDelivery.$DeliveryStatus(
      "Ok",
      Data$dFunctor.arrayMap(readDeliveryInfo)(response.restaurants)
    ));
  }
  return Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure(Restaumatic$dServices$dDelivery.$DeliveryStatus(
    "ChangeRestaurant",
    (() => {
      const $0 = Data$dArray.index(response.restaurants)(0);
      const $1 = (() => {
        if ($0.tag === "Just") { return $0._1; }
        $runtime.fail();
      })();
      return {
        restaurantId: $1.restaurant_id,
        restaurantName: $1.restaurant_name,
        path: $1.path,
        deliveryInfo: {
          restaurantId: $1.restaurant_id,
          restaurantName: $1.restaurant_name,
          restaurantSlug: $1.restaurant_slug,
          path: $1.path,
          deliveryCost: $1.delivery_cost,
          freeThreshold: $1.free_threshold,
          minOrderValue: $1.min_order_value
        }
      };
    })()
  ));
};
const fromRawResponse = restaurantId => f => Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind(Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind(Foreign$dIndex.unsafeReadProp(Data$dIdentity.monadIdentity)("delivers")(f))(Foreign.readBoolean(Data$dIdentity.monadIdentity)))(delivers => {
  if (delivers) {
    return Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind(Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
      reflectSymbol: () => "restaurants"
    })((() => {
      const $0 = Data$dArray$dNonEmpty$dSerialized.decodeNonEmptyArray({
        decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
          reflectSymbol: () => "restaurant_slug"
        })({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "restaurant_name"})({
          decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
        })())({reflectSymbol: () => "restaurant_id"})({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "path"})({
          decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
        })())({reflectSymbol: () => "min_order_value"})({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode})())({reflectSymbol: () => "free_threshold"})({
          decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dMoney$dRounded.decodeMoney.decode)
        })())({reflectSymbol: () => "delivery_cost"})({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode})())({reflectSymbol: () => "delivers"})({
          decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)
        })()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
      });
      return {decodeWithOptions: v => $0.decode};
    })())()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)(f))(fromRawDeliveryResponse(restaurantId));
  }
  return Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure(Restaumatic$dServices$dDelivery.WontDeliver);
});
const deliveryMethodToFormFields = v => {
  if (v.tag === "DeliveryMethodPickup") { return [Data$dTuple.$Tuple("delivery_method", Data$dMaybe.$Maybe("Just", "1"))]; }
  if (v.tag === "DeliveryMethodShipment") {
    return [
      Data$dTuple.$Tuple("delivery_method", Data$dMaybe.$Maybe("Just", "0")),
      Data$dTuple.$Tuple("delivery_address[street]", Data$dMaybe.$Maybe("Just", v._1.address.street)),
      Data$dTuple.$Tuple("delivery_address[street_number]", Data$dMaybe.$Maybe("Just", v._1.address.streetNumber)),
      Data$dTuple.$Tuple("delivery_address[city]", Data$dMaybe.$Maybe("Just", v._1.address.city)),
      Data$dTuple.$Tuple("delivery_address[post_code]", Data$dMaybe.$Maybe("Just", v._1.address.postCode)),
      Data$dTuple.$Tuple("delivery_address[apt_number]", Data$dMaybe.$Maybe("Just", v._1.address.aptNumber)),
      Data$dTuple.$Tuple("delivery_address[floor]", Data$dMaybe.$Maybe("Just", v._1.address.floor)),
      Data$dTuple.$Tuple("delivery_address[country]", Data$dMaybe.$Maybe("Just", Restaumatic$dCountries.showCountry.show(v._1.address.country))),
      Data$dTuple.$Tuple("delivery_address[latitude]", Data$dMaybe.$Maybe("Just", Data$dShow.showNumberImpl(v._1.location.latitude))),
      Data$dTuple.$Tuple("delivery_address[longitude]", Data$dMaybe.$Maybe("Just", Data$dShow.showNumberImpl(v._1.location.longitude)))
    ];
  }
  if (v.tag === "DeliveryMethodNoContactDelivery") {
    return [
      Data$dTuple.$Tuple("delivery_method", Data$dMaybe.$Maybe("Just", "3")),
      Data$dTuple.$Tuple("delivery_address[street]", Data$dMaybe.$Maybe("Just", v._1.address.street)),
      Data$dTuple.$Tuple("delivery_address[street_number]", Data$dMaybe.$Maybe("Just", v._1.address.streetNumber)),
      Data$dTuple.$Tuple("delivery_address[city]", Data$dMaybe.$Maybe("Just", v._1.address.city)),
      Data$dTuple.$Tuple("delivery_address[post_code]", Data$dMaybe.$Maybe("Just", v._1.address.postCode)),
      Data$dTuple.$Tuple("delivery_address[apt_number]", Data$dMaybe.$Maybe("Just", v._1.address.aptNumber)),
      Data$dTuple.$Tuple("delivery_address[floor]", Data$dMaybe.$Maybe("Just", v._1.address.floor)),
      Data$dTuple.$Tuple("delivery_address[country]", Data$dMaybe.$Maybe("Just", Restaumatic$dCountries.showCountry.show(v._1.address.country))),
      Data$dTuple.$Tuple("delivery_address[latitude]", Data$dMaybe.$Maybe("Just", Data$dShow.showNumberImpl(v._1.location.latitude))),
      Data$dTuple.$Tuple("delivery_address[longitude]", Data$dMaybe.$Maybe("Just", Data$dShow.showNumberImpl(v._1.location.longitude)))
    ];
  }
  if (v.tag === "DeliveryMethodDineIn") { return [Data$dTuple.$Tuple("delivery_method", Data$dMaybe.$Maybe("Just", "2"))]; }
  $runtime.fail();
};
const toRawRequest = req => Data$dSemigroup.concatArray([
  Data$dTuple.$Tuple("restaurant_id", req.restaurantId.tag === "Just" ? Data$dMaybe.$Maybe("Just", Data$dShow.showIntImpl(req.restaurantId._1)) : Data$dMaybe.Nothing)
])(deliveryMethodToFormFields(req.deliveryMethod));
const deliveryCost = config => request => Utils$dDataLoading.simpleRequest({
  method: Data$dEither.$Either("Left", Data$dHTTP$dMethod.POST),
  url: config.urlPrefix + "/api/v1/delivery_cost",
  headers: [Affjax$dRequestHeader.$RequestHeader("RequestHeader", "Accept", "application/json")],
  content: Data$dMaybe.$Maybe("Just", Affjax$dRequestBody.$RequestBody("FormURLEncoded", toRawRequest(request))),
  username: Data$dMaybe.Nothing,
  password: Data$dMaybe.Nothing,
  withCredentials: false,
  responseFormat: Affjax$dResponseFormat.ignore,
  timeout: Data$dMaybe.Nothing
})((() => {
  const $0 = Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity);
  const $1 = Foreign$dJSON.decodeJSONWith(Foreign$dGeneric$dClass.foreignDecode.decode);
  const $2 = fromRawResponse(request.restaurantId);
  return a => $0.bind($1(a))($2);
})());
const deliveryBackendWithConfig = config => ({deliveryCost: deliveryCost(config)});
const defaultConfig = {urlPrefix: ""};
const deliveryBackend = {deliveryCost: /* #__PURE__ */ deliveryCost(defaultConfig)};
export {
  defaultConfig,
  deliveryBackend,
  deliveryBackendWithConfig,
  deliveryCost,
  deliveryMethodToFormFields,
  fromRawDeliveryResponse,
  fromRawResponse,
  readDeliveryInfo,
  toRawRequest
};
